module.exports = __webpack_public_path__ + "img/pqlife.9791ccea.png";